module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_halloween_de-bb26f61a9d59e5777cf367b44f56c225.png";